var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "reportModal",
          "data-focus": "false",
          "data-keyboard": "false",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable" },
          [
            _c("ValidationObserver", {
              ref: "letter",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c("div", { staticClass: "letter-modal" }, [
                        _c("div", { staticClass: "note-wrap" }, [
                          _c("div", { staticClass: "letter-title" }, [
                            _vm._v("報到通知"),
                          ]),
                          _c("div", { staticClass: "note-title" }, [
                            _vm._v("可動態套入信件內容，請參考以下參數"),
                          ]),
                          _c("div", { staticClass: "note-table" }, [
                            _vm.mailParameters
                              ? _c(
                                  "table",
                                  _vm._l(
                                    _vm.mailParameters,
                                    function (parameter) {
                                      return _c(
                                        "tr",
                                        { key: parameter.MailParameterCode },
                                        [
                                          _c("th", [
                                            _vm._v(
                                              _vm._s(
                                                parameter.MailParameterName
                                              )
                                            ),
                                          ]),
                                          _c("td", [
                                            _c("span", [_vm._v("{{")]),
                                            _vm._v(
                                              _vm._s(
                                                parameter.MailParameterCode
                                              )
                                            ),
                                            _c("span", [_vm._v("}}")]),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "modal-content border-0" },
                              [
                                _c(
                                  "perfect-scrollbar",
                                  { staticClass: "modal-body" },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("姓名："),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.mail.Name)),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: {
                                            rules: "required",
                                            name: "單位",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("任用單位："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("treeselect", {
                                                      attrs: {
                                                        options:
                                                          _vm.departmentOptions,
                                                        searchable: true,
                                                        "show-count": true,
                                                        "default-expand-level": 1,
                                                        placeholder: "請選擇",
                                                        valueFormat: "object",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "option-label",
                                                            fn: function ({
                                                              node,
                                                              shouldShowCount,
                                                              count,
                                                              labelClassName,
                                                              countClassName,
                                                            }) {
                                                              return _c(
                                                                "label",
                                                                {
                                                                  class:
                                                                    labelClassName,
                                                                  attrs: {
                                                                    for: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        node.label
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  shouldShowCount
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          class:
                                                                            countClassName,
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " (" +
                                                                              _vm._s(
                                                                                count
                                                                              ) +
                                                                              ") "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: _vm.mail.Group,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.mail,
                                                            "Group",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "mail.Group",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "工作職稱",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("職務名稱："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value: _vm.mail.Job,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "Job",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.Job",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.positionOptions,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.PositionCode,
                                                              attrs: {
                                                                label:
                                                                  item.PositionName,
                                                                value:
                                                                  item.PositionName,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("報到日期："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("date-picker", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        format: "YYYY-MM-DD",
                                                        valueType: "format",
                                                        placeholder:
                                                          "YYYY-MM-DD",
                                                        "disabled-date":
                                                          _vm.$common
                                                            .disabledDateBeforeToday,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.mail.ReportedDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.mail,
                                                            "ReportedDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "mail.ReportedDate",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "reportTime",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("報到時間："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("date-picker", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        format: "HH:mm",
                                                        "value-type": "format",
                                                        type: "time",
                                                        "default-value":
                                                          new Date().setHours(
                                                            8,
                                                            0,
                                                            0,
                                                            0
                                                          ),
                                                        "minute-step": 5,
                                                        placeholder: "HH:mm",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.mail.ReportedTime,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.mail,
                                                            "ReportedTime",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "mail.ReportedTime",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("報到地點："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value: _vm.mail.Place,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "Place",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.Place",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.reportPlaceOptions,
                                                        function (place) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: place.Guid,
                                                              attrs: {
                                                                label:
                                                                  place.Name,
                                                                value:
                                                                  place.Name,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "required",
                                            name: "聯絡資訊",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _c("span", [
                                                          _vm._v("聯絡資訊："),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder: "請選擇",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mail
                                                              .ContactInfo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "ContactInfo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.ContactInfo",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.contactOptions,
                                                        function (person) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: person.Guid,
                                                              attrs: {
                                                                label:
                                                                  person.Name,
                                                                value:
                                                                  person.Name,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("附件："),
                                        ]),
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              "auto-upload": false,
                                              "show-file-list": false,
                                              "on-change": _vm.uploadFile,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v(" 點擊上傳 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.uploadFileList
                                          ? _vm._l(
                                              _vm.uploadFileList,
                                              function (file) {
                                                return _c(
                                                  "div",
                                                  { key: file.FileGuid },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "20px",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.$common.downloadFile(
                                                              {
                                                                fileGuid:
                                                                  file.FileGuid,
                                                                fileType:
                                                                  file.FileContentType,
                                                              }
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("eva-icon", {
                                                          attrs: {
                                                            fill: "#000",
                                                            name: "attach-outline",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "15px",
                                                              "vertical-align":
                                                                "text-top",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  file.FileName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              display:
                                                                "inline-block",
                                                              position:
                                                                "absolute",
                                                              right: "25px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.removeFile(
                                                                  {
                                                                    fileGuid:
                                                                      file.FileGuid,
                                                                    fileGroupGuid:
                                                                      file.FileGroupGuid,
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("eva-icon", {
                                                              attrs: {
                                                                fill: "#000",
                                                                name: "trash-2-outline",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v(" 信件範本： "),
                                      ]),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedTemplateGuid,
                                              expression:
                                                "selectedTemplateGuid",
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.selectedTemplateGuid =
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                              },
                                              _vm.getMailTemplateDetail,
                                            ],
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("請選擇")]
                                          ),
                                          _vm._l(
                                            _vm.mailTemplates,
                                            function (template) {
                                              return _c(
                                                "option",
                                                {
                                                  key: template.MailTemplateGuid,
                                                  domProps: {
                                                    value:
                                                      template.MailTemplateGuid,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        template.MailTemplateName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: {
                                            rules: "required",
                                            name: "信件主旨",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mark",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v("信件主旨： "),
                                                      ]
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.mail
                                                              .MailSubject,
                                                          expression:
                                                            "mail.MailSubject",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control w-100",
                                                      attrs: {
                                                        placeholder:
                                                          "請輸入信件主旨或選擇範本",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.mail.MailSubject,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.mail,
                                                            "MailSubject",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: {
                                            rules: "required",
                                            name: "信件內容",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c(
                                                      "label",
                                                      { attrs: { for: "" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mark",
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                        _vm._v("信件內容： "),
                                                      ]
                                                    ),
                                                    _c("VueEditor", {
                                                      staticStyle: {
                                                        background:
                                                          "rgb(255, 255, 255)",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.mail
                                                            .MailTemplateBody,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.mail,
                                                            "MailTemplateBody",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "mail.MailTemplateBody",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "modal-footer" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: { type: "reset" },
                                      on: { click: _vm.closeReportMailModal },
                                    },
                                    [_vm._v(" 取消 ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return handleSubmit(_vm.showPreview)
                                        },
                                      },
                                    },
                                    [_vm._v(" 預覽 ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.clickDisabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return handleSubmit(_vm.sendLetter)
                                        },
                                      },
                                    },
                                    [_vm._v(" 寄出 ")]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "previewMail",
          "data-focus": "false",
          "data-keyboard": "false",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg",
          },
          [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(0),
                _c("perfect-scrollbar", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "preview-body row" }, [
                    _c("div", { staticClass: "col-1" }, [_c("Logo")], 1),
                    _c(
                      "div",
                      {
                        staticClass: "col-10",
                        staticStyle: { "padding-left": "5px" },
                      },
                      [
                        _vm._v(" 收件者："),
                        _vm._l(
                          _vm.previewMail.Recipients,
                          function (recipient, index) {
                            return _c(
                              "span",
                              { key: recipient[index] },
                              [
                                _c("el-tag", { attrs: { size: "small" } }, [
                                  _vm._v(
                                    _vm._s(
                                      recipient.Name +
                                        "(" +
                                        recipient.Address +
                                        ")"
                                    )
                                  ),
                                ]),
                                _vm._v("; "),
                              ],
                              1
                            )
                          }
                        ),
                        _c("br"),
                        _vm._v(" 副本："),
                        _vm._l(_vm.previewMail.CCs, function (cc, index) {
                          return _c(
                            "span",
                            { key: cc[index] },
                            [
                              _c(
                                "el-tag",
                                { attrs: { size: "small", type: "info" } },
                                [
                                  _vm._v(
                                    _vm._s(cc.Name + "(" + cc.Address + ")")
                                  ),
                                ]
                              ),
                              _vm._v("; "),
                            ],
                            1
                          )
                        }),
                        _c("br"),
                        _c("span", [
                          _vm._v("主旨：" + _vm._s(_vm.previewMail.Subject)),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _c("div", {
                    staticClass: "mt-1",
                    domProps: { innerHTML: _vm._s(_vm.previewMail.Body) },
                  }),
                ]),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("預覽信件")]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "aria-label": "Close",
            "data-dismiss": "modal",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }